/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
// ! Interessante notar que a classe foi feita depois de tudo pronto, ou seja, já estava com as variáveis todas prontas
// TODO utilizar essa classe em moduleUtils

/**
 * Importação da classe genérica para requisições em serviços
 */
import GenericCrud from 'services/crud/GenericCrud';
/**
 * Impoetação da classe que realiza as requisições no GeoServer
 */
import GeoServer from 'services/crud/GeoServer';
import LayerMetadataService from 'services/crud/LayerMetadata';
import WMS from 'services/crud/WMS';
import * as geoJson from 'services/geoJson';
import { toUrlFormat } from 'services/utils/formaters';
import generateId from 'services/utils/generateRandomId';
import { applyLabelSetting } from 'services/utils/layerUtils';
import slugify from 'services/utils/slugify';

import selectedFeaturesStyles from './selectedFeaturesStyles.json';

import LayerStyle from 'views/MapView/services/symbologiesStyles.json';

import Icon from '@map/components/Icons';
import shpwrite from '@mapbox/shp-write';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
import colorGradient from 'javascript-color-gradient';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
import NonTiledLayer from 'leaflet.nontiledlayer';
import tokml from 'tokml';

export default class Layer {
  /**
   *
   * @param {string} parentId Define o identificador do objeto pai, geralmente o id da categoria mãe da camada
   * @param {('interna', 'externa', 'importada', 'criada')} type Define um tipo gênerico para a camaa, sendo ela 'interna', 'externa' ou 'importada'
   * @param {string} externalServiceId Para o caso da camada ser externa deve-se informar o seu identificador
   * @param {string} alias Apelido ou titulo da camada
   * @param {string} abstract Resumo sobre a camada
   * @param {string} geoserverName Para o caso da camada ser interna, deve se passar seu nome como está no geoserver
   * @param {string} geoserverWorkspace Para o caso da camada ser interna, deve se passar o nome da sua workspace como está no geoserver
   * @param {object} additionalProps Objeto contendo as configurações e permissões da camada
   * @param {number} order Deve se passar sua ordem para a exibição no treelist
   */
  constructor(
    parentId,
    type,
    externalServiceId,
    alias,
    abstract,
    geoserverName,
    geoserverWorkspace,
    additionalProps,
    order
  ) {
    this.id = generateId();
    this.parentId = parentId;
    this.type = type;
    this.externalServiceId = externalServiceId;
    this.alias = alias;
    this.abstract = abstract;
    this.geoserverName = geoserverName;
    this.geoserverWorkspace = geoserverWorkspace;
    this.additionalProps = additionalProps;
    this.order = order;

    this.properties = null;
    this.layerType = null; //Define um tipificação mais abrangente da camada, podendo ser featureType, wmsLayer, external, coverageLayer, etc
    this.dataType = null; //Define o tipo do dado, podendo ser raster, ponto, linha ou poligono
    this.fileType = null; //Define o tipo do arquivo ao importar uma camada.
    this.leafletLayer = null;
    this.geoRasterLayer = null;
    this.layerStyle = { ...LayerStyle[0] };
    this.metadata = null;

    this.treeListType = 'layer';

    this.isSelected = false; //Indica se a camada foi está selecionada
    this.visible = true; //Indica se a camada foi está visivel
    this.layerStyle.opacity = 1; //Indica se a camada foi está visivel
    this.layerStyle.fillOpacity = 0.2; //Indica o preenchimento da camada
    this.zIndex = 10; //Indica o ZIndex da camada
    this.layerStatus = 'loading'; // Indica se a layer foi carregada, ou está com erro

    this.selectedFeatures = []; // Feições selecionadas
    this.selectedFeaturesLayer = null;
    this.selectedLabelColumn = null; // Coluna definida como rótulo

    this.statusLabelVisibility = true; // visibilidade do rótulo

    this.classColumn = null; // Coluna da classificação
    this.colorScale = null; // Coluna da classificação
    this.classList = []; // Lista de classificações (simbologia)
    this.settingsLabel = {}; // Configurações do rótulo

    this.apiMapper = {
      abstract: 'resumo',
      additionalProps: 'configuracao',
      alias: 'apelido',
      externalServiceId: 'servico_externo_id',
      geoserverName: 'nome_geoserver',
      geoserverWorkspace: 'workspace_geoserver',
      order: 'ordem',
      parentId: 'categoria_mae',
      type: 'tipo',
    };

    this.events = [];
  }

  /** UTILITÁRIOS */
  /**
   * @returns {string} Retorna um id gerado pelas
   * propriedades da camada
   */
  static generateId(json) {
    // Por enquanto carregando em json, mas deve carregar uma classe cls
    return `${json.parentId}---${
      json.type === 'externa' ? 'external' : json.geoserverWorkspace
    }:${json.type === 'externa' ? json.externalServiceId : json.geoserverName}`;
  }

  /**
   * Método que realiza o preenchimento dos dados da camada,
   * tando internas, buscando do geoServer, como as externas.
   */
  async loadData() {
    if (!this.properties) {
      // Verifica se o tipo da camada é interna
      if (this.type === 'interna') {
        // Instancia GeoServer
        const geoServer = new GeoServer();
        try {
          // Obtém dados da camada no GeoServer
          const geoServerData = await geoServer.getOne(
            `${this.geoserverWorkspace}:${this.geoserverName}`
          );
          //Obtido através da key, pois pode variar entre featureType, coverage, wmsLayer, wmtsLayer, etc...
          const objType = Object.keys(geoServerData.data.camada[0])[0];
          this.layerType = objType;

          //Obtenção do tipo do dado da camada
          if (this.layerType === 'featureType') {
            // Obtém os atributos da camada
            const attributes =
              geoServerData.data.camada[0].featureType.attributes.attribute;
            // Obtém o atributo geometria da camada
            const geomAttr = attributes.find(
              (v) => v.name === 'the_geom' || v.name === 'geom'
            );
            // Obtém o tipo de geometria
            if (geomAttr && geomAttr.binding) {
              this.dataType = geomAttr.binding.split('.').pop();
            } else {
              this.dataType = 'Point';
            }
          } else {
            this.dataType = 'Raster';
          }
          this.properties = geoServerData.data.camada[0][this.layerType];
        } catch (error) {
          console.error(
            `Falha ao consultar camada ${this.geoserverName} : `,
            error
          );
        }
      } else if (this.type === 'externa') {
        const externalServiceCrud = new GenericCrud('servico-externo', {
          post: 'private',
          delete: 'private',
          put: 'private',
        });
        try {
          // Obtém dados da camada externa
          const externalServiceData = await externalServiceCrud.getOne(
            this.externalServiceId
          );
          this.properties = externalServiceData.data;
          this.dataType = this.properties.tipo_dado;
        } catch (error) {
          console.error(
            `Erro na requisição para buscar serviço externo id : ${this.externalServiceId}`,
            error
          );
        }
      } else if (this.type === 'importada' || this.type === 'criada') {
        // Obtém os dados das camadas importadas ou criadas
        let childLayer = this.leafletLayer.getLayers()[0];
        // this.dataType = childLayer.feature.geometry.type;
        this.dataType = childLayer.pm.textArea
          ? 'Text'
          : childLayer.feature.geometry.type;
        this.additionalProps = { service: 'NO' };
      } else if (this.type === 'importada-raster') {
        this.dataType = 'Raster';
        this.additionalProps = { service: 'NO' };
      }
    }
  }

  /**
   * Método que seta as propriedade da
   * camada externa obtida por Geoservico
   * @param {String} urlFullService
   * @param {Object} layerGeoservice
   */
  async loadDataGeoservice(urlFullService, layerGeoservice) {
    if (this.type === 'externa' && !this.properties) {      
      // Adiciona atributos ao properties
      this.properties = {
        titulo: layerGeoservice.Title,
        link_servico: this.getGeoserviceLink(
          urlFullService,
          layerGeoservice.Name
        ),
        name: layerGeoservice.Name,
        srs: layerGeoservice.SRS.replace(":", ""),
      };
    }
  }

  /**
   * Método para o carregamento do bbox, básicamente se aplica as camadas externas
   */
  async loadBoundingBox() {
    if (this.type === 'externa' && !this.properties.BoundingBox) {
      try {
        // Obtém os capabilities do serviço da camada externa
        let getCapabilities = await WMS.getCapabilities(this.getServiceLink());
        // Método que obtém as "subcamadas" da camada
        const getLayers = (capabilityLayers) => {
          let returnLayers = [];
          if (Array.isArray(capabilityLayers)) {
            capabilityLayers.forEach((l) => {
              if (l.Layer) {
                returnLayers = [...returnLayers, ...getLayers(l.Layer)];
              } else {
                returnLayers.push(l);
              }
            });
          } else if (capabilityLayers.Layer) {
            if (!Array.isArray(capabilityLayers.Layer)) {
              returnLayers.push(capabilityLayers.Layer);
            } else {
              returnLayers = [
                ...returnLayers,
                ...getLayers(capabilityLayers.Layer),
              ];
            }
          } else {
            returnLayers = [...returnLayers, capabilityLayers];
          }
          return returnLayers;
        };

        // Nome da camada com o workspace
        let layerNameWithWorkspace = this.getLayerNameParam();
        let layerName = null;
        if (layerNameWithWorkspace) {
          // Nome da camada
          layerName = layerNameWithWorkspace.split(':').pop();
        }
        // "Subcamadas" da camada
        let layers = getLayers(getCapabilities.data.metadados.Capability.Layer);
        // Capabilities da camada
        let layerCapabilities = layers.find(
          (l) => l.Name.split(':').pop() === layerName
        );
        if (!layerName) {
          layerCapabilities = layers[0];
        }
        // Seta as propriedade da camada
        this.properties = { ...this.properties, ...layerCapabilities };
      } catch (error) {
        console.error(
          `Erro ao obter os capabilities da camada ${this.getTitle()}: ${error}`
        );
      }
    }
    return this.getBoundingBox();
  }

  /**
   * Método para o carregamento dos metadados da camada
   */
  async loadMetadata() {
    if (!this.metadata) {
      try {
        // Obtém os metadados da camada através do seu serviço
        let layerMetadata = await LayerMetadataService.get(
          this.getMetadataXmlLink()
        );
        // Seta os metadados da camada
        this.metadata = layerMetadata.data.metadados;
      } catch (error) {
        console.error(
          `Erro ao obter os metadados da camada: ${this.getTitle()}`,
          error
        );
      }
    }
    return this.metadata;
  }

  /**
   * Realiza o carregamento da camada no mapa
   * @param {*} map
   */
  async loadLayer(map, filter) {    
    // Verifica se a camada possui tipo e se é do tipo interna
    if (this.type && this.type === 'interna') {
      // Obtem o tipo de serviço da camada. WMS ou WFS
      const serviceType = this.getService();

      if (serviceType === 'WMS') {
        // Configurações do WMS
        const optionsWms = {
          layers: this.getLayerNameParam(),
          format: 'image/png',
          transparent: true,
          pane: 'mixedPane',
          tiled: true,
          maxZoom: 20,
          authkey: process.env.REACT_APP_GEO_SERVER_AUTH_KEY,
        };
        if(filter) optionsWms.cql_filter = filter;
        let wmsLayer;

        // Verifica se a camada esta configurada para
        // ser carregada em Single Tile
        if (this.additionalProps && this.additionalProps.loadSingleTile && this.additionalProps.loadSingleTile === "1") {
          wmsLayer = new NonTiledLayer.WMS(this.getServiceLink('WMS'), {
            ...optionsWms,
            crossOrigin: 'anonymous',
          });
        } else {
          wmsLayer = L.tileLayer.wms(this.getServiceLink('WMS'), optionsWms);
        }

        // Adiciona camada ao mapa
        wmsLayer.addTo(map);
        // Define o objeto camada criado pelo leaflet
        this.setLeafletLayer(wmsLayer);
        // Seta opacity da camada
        this.leafletLayer.setOpacity(this.layerStyle.opacity);
        // Define o zindex da camada
        this.setZIndex(this.zIndex);
        // Altera o estado da camada para carregado
        this.layerStatus = 'loaded';
        // Dispara callback associada ao evento de camada carregada
        this._fireEvent('load-layer', { layer: this });
        return this;
      } else if (serviceType === 'WFS') {
        try {
          // Obtém dados GeoJson do serviço da camada
          const geoJsonData = await geoJson.get(
            this.getServiceLink(),
            this.getLayerNameParam()
          );
          // Customiza renderização canvas
          let customRender = L.canvas({ pane: 'mixedPane' });
          // Configura o options
          let options = {
            pane: 'mixedPane',
            renderer: customRender,
          };
          // Se o tipo da camada for ponto, adiciona mais configurações ao options
          if (this.dataType === 'Point' || this.dataType === 'MultiPoint') {
            options = {
              ...options,
              pointToLayer: function (feature, latlng) {
                return L.circleMarker(latlng, {
                  pane: 'mixedPane',
                  renderer: customRender,
                  radius: 5,
                  color: '#219e36',
                  weight: 1,
                  opacity: 1.0,
                  lineCap: 'round',
                  lineJoin: 'round',
                  dashArray: null,
                  dashOffset: null,
                  fillColor: '#25db44',
                  fillOpacity: 1.0,
                  fillRule: 'evenodd',
                });
              },
            };
          }
          // Cria a camada no formato GeoJSON e adiciona ao mapa
          const geoJsonLayer = L.geoJSON(geoJsonData.data, options).addTo(map);
          // Define o objeto camada criado pelo leaflet
          this.setLeafletLayer(geoJsonLayer);
          // Seta opacity e fillOpacity da camada
          this.leafletLayer.setStyle({
            opacity: this.layerStyle.opacity,
            fillOpacity: this.layerStyle.fillOpacity,
          });
          // Define o zindex da camada
          this.setZIndex(this.zIndex);
          // Altera o estado da camada para carregado
          this.layerStatus = 'loaded';
          // Dispara callback associada ao evento de camada carregada
          this._fireEvent('load-layer', { layer: this });
          return this;
        } catch (error) {
          console.error(
            `Erro ao tentar obter GeoJSON da camada ${this.getTitle()}`,
            error
          );
          // Altera o estado da camada para error
          this.layerStatus = 'error';
          // Dispara callback associada ao evento de falha ao carregar camada
          this._fireEvent('load-layer-fail', { layer: this });
        }
      }
    } else if (this.type === 'externa') {
      if (this.properties) {        
        // Obtém a camada WMS externa do Leaflet e adiciona ao mapa
        const wmsLayer = L.tileLayer
          .wms(this.getServiceLink(), {
            layers: this.externalServiceId
              ? this.getLayerNameParam()
              : this.properties.name,
            format: 'image/png',
            transparent: true,
            pane: 'mixedPane',
            tiled: 'true',
            crs: L.CRS[this.getCrs()],
          })
          .addTo(map);

        // Define o objeto camada criado pelo leaflet
        this.setLeafletLayer(wmsLayer);
        // Seta opacity e fillOpacity da camada
        this.leafletLayer.setOpacity(this.layerStyle.opacity);
        // Define o zindex da camada
        this.setZIndex(this.zIndex);
        // Altera o estado da camada para carregado
        this.layerStatus = 'loaded';
        // Dispara callback associada ao evento de camada carregada
        this._fireEvent('load-layer', { layer: this });
        return this;
      } else {
        // Altera o estado da camada para error
        this.layerStatus = 'error';
        // Dispara callback associada ao evento de falha ao carregar camada
        this._fireEvent('load-layer-fail', { layer: this });
      }
    } else if (
      this.type === 'importada' ||
      this.type === 'criada' ||
      this.type === 'importada-raster'
    ) {
      // Adiciona camada ao mapa
      this.leafletLayer.addTo(map);
      // Define o zindex da camada
      this.setZIndex(this.zIndex);
      // Altera o estado da camada para carregado
      this.layerStatus = 'loaded';
      // Dispara callback associada ao evento de camada carregada
      this._fireEvent('load-layer', { layer: this });
      return this;
    }
  }

  /**
   * Método para verificar se foi concedida a permissão de download
   * da camada
   */
  canDownload() {
    // Para camadas do tipo interna, verifica se a mesma foi configurada
    // para permitir o download. Se a camada for criada, não há configuração,
    // portanto é permitido o download
    if (
      ((this.type === 'interna' &&
        this.additionalProps &&
        this.additionalProps.download &&
        this.additionalProps.download === '1') ||
      this.type === 'criada' ||
      this.type === 'importada') &&
      this.dataType !== 'Text'
    ) {
      return true;
    }
    return false;
  }

  /**
   * Método para verificar se foi definido link manual de download da camada
   */
  hasManualLinkDownload() {
    if (
      this.additionalProps &&
      this.additionalProps.server &&
      this.additionalProps.server === 'Link externo' &&
      this.additionalProps.link
    ) {
      return true;
    }
    return false;
  }

  /**
   * Método para verificar se foi cencedida a permissão de link
   * dos serviços da camada
   */
  canShowLinkService() {
    // Para camadas do tipo interna, verifica se a mesma foi configurada
    // para permitir exibir seus serviços configurados no GeoServer.
    // Se a camada for externa, não há configuração,
    // portanto é permitido disponibilizar seu serviço
    if (
      (this.type === 'interna' &&
        this.additionalProps &&
        this.additionalProps.showServiceLink &&
        this.additionalProps.showServiceLink === '1') ||
      this.type === 'externa'
    ) {
      return true;
    }
    return false;
  }

  /**
   * Método para verificar se camada possui serviço WMS disponibilizado
   */
  canShowInternalEnableService(enableService) {
    if (this.properties && this.properties.disabledServices) {
      let disabledServices = this.properties.disabledServices.string;
      return disabledServices.indexOf(enableService) === -1;
    } else if (this.type === 'interna') {
      return true;
    }
    return false;
  }

  /**
   * Método para verificar se a camada foi definida como inicial
   */
  isInitial() {
    return this.additionalProps && this.additionalProps.mainMenu;
  }

  /**
   * Método que retorna a url para obtenção da imagem de pré-visualização
   */
  async getPreviewUrl() {
    await this.loadBoundingBox();
    let urlsPreview = [];
    let getMapParams = {
      service: 'WMS',
      version: '1.1.1',
      request: 'GetMap',
      layers: null,
      bbox: null,
      width: 256,
      height: 256,
      srs: null,
      format: 'image/png',
      transparent: 'true',
      tiled: 'true',
    };
    
    const getWidthRatio = (boundBox) => {
      let distanceX, distanceY, ratio;
      distanceX =
        Number.parseFloat(boundBox.maxx) - Number.parseFloat(boundBox.minx);
      distanceY =
        Number.parseFloat(boundBox.maxy) - Number.parseFloat(boundBox.miny);
      ratio = distanceX / distanceY;
      return ratio;
    };

    if (this.getBoundingBox()) {
      let boundingBox = this.getBoundingBox();
      let subBoxes;
      // Calculando a área do bbox
      const areaBbox = (boundingBox.maxx - boundingBox.minx) * (boundingBox.maxy - boundingBox.miny);
      getMapParams.layers = this.getLayerNameParam();
      getMapParams.srs = boundingBox.crs ? boundingBox.crs : boundingBox.SRS;

      if(areaBbox <= 45 || areaBbox >= 100){
        getMapParams.height = 220;
        let getMapParamsWidth = Math.floor(getMapParams.height * getWidthRatio(boundingBox));
        getMapParams.width = getMapParamsWidth;
        getMapParams.width = Math.round(getMapParams.width / 2);
        getMapParams.height = Math.round(getMapParams.height / 2);
        
        // Calcular as coordenadas para as 4 sub-caixas delimitadoras
        let midX = (Number.parseFloat(boundingBox.maxx) + Number.parseFloat(boundingBox.minx)) / 2;
        let midY = (Number.parseFloat(boundingBox.maxy) + Number.parseFloat(boundingBox.miny)) / 2;

        subBoxes = [
          { minx: boundingBox.minx, miny: boundingBox.miny, maxx: midX, maxy: midY },
          { minx: midX, miny: boundingBox.miny, maxx: boundingBox.maxx, maxy: midY },
          { minx: boundingBox.minx, miny: midY, maxx: midX, maxy: boundingBox.maxy },
          { minx: midX, miny: midY, maxx: boundingBox.maxx, maxy: boundingBox.maxy }
        ];
      }else{
        subBoxes = [
          { minx: -56.25, miny: -22.5, maxx: -45, maxy: -11.25 },
          { minx: -45, miny: -22.5, maxx: -33.75, maxy: -11.25 },
          { minx: -56.25, miny: -11.25, maxx: -45, maxy: 0 },
          { minx: -45, miny: -11.25, maxx: -33.75, maxy: 0 }
        ];
      }
    
      for (let subBox of subBoxes) {
        getMapParams.bbox = `${subBox.minx},${subBox.miny},${subBox.maxx},${subBox.maxy}`;
        urlsPreview.push(this.getFullServiceLink('WMS', getMapParams));
      }
    }
    return urlsPreview;
  }

  /**
   * Retorna o link completo do serviço
   *
   * @param {String} service Apenas se aplica as internas. Ex: WMS, WFS...
   * @param {*} customParams
   * @param {boolean} toLoadInGis
   */
  getFullServiceLink = (service, customParams = null, toLoadInGis = true) => {
    let baseUrl = `${this.getServiceLink(service.toUpperCase())}`;
    let urlParams = '';

    let wmsParams = {
      service: 'WMS',
      version: '1.1.1',
      request: 'GetMap',
      layers: this.getLayerNameParam(),
      format: 'image/png',
      transparent: 'true',
      tiled: 'true',
    };

    let wfsParams = {
      service: 'WFS',
      version: '2.0.0',
      request: 'GetFeature',
      typeName: this.getLayerNameParam(),
    };

    if (toLoadInGis) {
      wfsParams = {
        ...wfsParams,
        format: 'application/json',
      };
    } else {
      wfsParams = {
        ...wfsParams,
        outputFormat: 'application/json',
      };
    }

    let params = customParams
      ? customParams
      : service.toUpperCase() === 'WFS'
      ? wfsParams
      : wmsParams;
    Object.keys(params).forEach(
      (k) => (urlParams = `${urlParams}${k}=${params[k]}&`)
    );
    return `${baseUrl}?${urlParams}`;
  };

  /**
   * Obtem o link para download da camada
   *
   * @param {('kml'|'shapefile')} format Deve se passar o formato desejado, entre KML e Shapefile
   */
  getDownloadLink(format) {
    let availableFormats = {
      kml: 'application/vnd.google-earth.kml+xml',
      shapefile: 'SHAPE-ZIP',
    };
    return (
      this.canDownload() &&
      `${
        process.env.REACT_APP_GEO_SERVER_HOST
      }/wfs?service=WFS&version=1.0.0&request=GetFeature&format_options=CHARSET:UTF-8&outputFormat=${
        availableFormats[format || 'shapefile']
      }&typeName=${this.getLayerNameParam()}`
    );
  }

  /**
   * Converte o geoJson da layer em Shapefile e realiza o download do mesmo
   */
  getShapefile = () => {
    let fileName = slugify(this.getTitle());
    let objGeoJson = this.leafletLayer.toGeoJSON();
    let arrFeatures = [];
    // TODO: Foi necessário converter as feições multipoligono para polígono para que
    // a biblioteca shp-write exportasse as camadas corretamente. Porém multiplicando registros
    // de feições muitipolígono conforme quantidade de geometrias.
    // SErá necessário trabalhar na biblioteca para corrigir esse problema.
    turf.flattenEach(
      objGeoJson,
      function (currentFeature, featureIndex, multiFeatureIndex) {
        arrFeatures.push(currentFeature);
      }
    );
    let ft = turf.featureCollection(arrFeatures);
    let shpBase64 = shpwrite.zip(ft, {
      folder: fileName,
      types: {
        point: fileName,
        polygon: fileName,
        line: fileName,
      },
      prj: 'GEOGCS["SIRGAS 2000",DATUM["Sistema_de_Referencia_Geocentrico_para_las_AmericaS_2000",SPHEROID["GRS 1980",6378137,298.257222101,AUTHORITY["EPSG","7019"]],AUTHORITY["EPSG","6674"]],PRIMEM["Greenwich",0,AUTHORITY["EPSG","8901"]],UNIT["degree",0.0174532925199433,AUTHORITY["EPSG","9122"]],AUTHORITY["EPSG","4674"]]',
    });

    shpBase64.then((shpBase64Response) => {
      let shpBlobCharacters = atob(shpBase64Response);
      const byteNumbers = new Array(shpBlobCharacters.length);
      for (let i = 0; i < shpBlobCharacters.length; i++) {
        byteNumbers[i] = shpBlobCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const shpBlob = new Blob([byteArray], { type: 'application/zip' });
      let linkElement = document.createElement('a');
      linkElement.href = window.URL.createObjectURL(shpBlob);
      linkElement.download = fileName + '.zip';
      linkElement.click();
    });
  };

  /**
   * Converte o geoJson da layer em KML e realiza o download do mesmo
   */
  getKmlFile = () => {
    let fileName = slugify(this.getTitle());
    let kmlContent = tokml(this.leafletLayer.toGeoJSON(), {
      documentName: this.getTitle(),
    });
    let kmlBlob = new Blob([kmlContent], {
      type: 'application/vnd.google-earth.kml+xml',
    });

    let linkElement = document.createElement('a');
    linkElement.href = window.URL.createObjectURL(kmlBlob);
    linkElement.download = fileName + '.kml';
    linkElement.click();
  };

  /**
   * Método para retornar o serviço, caso não configurado
   * sempre será retornado WMS
   */
  getService() {
    return this?.additionalProps?.service || 'WMS';
  }

  /**
   * Obtém as colunas da camada
   */
  getColumns() {
    let columnsList = [];
    let layerColumns =
      this.leafletLayer._layers[Object.keys(this.leafletLayer._layers)[0]]
        .feature.properties;
    Object.keys(layerColumns).forEach((k) =>
      columnsList.push({ label: k, value: k })
    );
    return columnsList;
  }

  /**
   * Método para setar o tipo do arquivo da camada ao importá-la
   *
   * @param {*} fileType
   */
  setFileType(fileType) {
    this.fileType = fileType;
  }

  /**
   * Método para setar o objeto de camada criado pelo leaflet
   * e assim ter mais domínio sobre o mesmo, para quaisquer
   * ação que dependa do mesmo
   *
   * @param {*} leafletLayer
   */
  setLeafletLayer(leafletLayer) {
    this.leafletLayer = leafletLayer;
  }

  /**
   * Método para setar o objeto de camada criado pelo leaflet
   * e assim ter mais domínio sobre o mesmo, para quaisquer
   * ação que dependa do mesmo
   *
   * @param {*} leafletLayer
   */
  setGeoRasterLayer(geoRasterLayer) {
    this.geoRasterLayer = geoRasterLayer;
  }

  /**
   * Método para setar o objeto de esstilo de camadas do leaflet
   *
   * @param {*} style
   */
  setLayerStyle(style) {
    this.layerStyle = style;
  }

  /**
   * Método para retornar o link base do serviço
   * @param {String} customService Apenas se aplica as internas. Ex: WMS, WFS...
   * @param {String} linkFullService
   */
  getServiceLink(customService = null, linkFullService = null) {
    if (this.type === 'interna') {
      let service = customService
        ? customService.toLowerCase()
        : this.getService().toLowerCase();
      return `${process.env.REACT_APP_GEO_SERVER_HOST}/${service}`;
    } else if (this.type === 'externa' && !this.properties) {
      return linkFullService
        ? `${linkFullService.replace(/\?[\w\W]+/, '')}`
        : null;
    } else if (this.type === 'externa') {
      return `${this.properties.link_servico.replace(/\?[\w\W]+/, '')}`;
    }
  }

  /**
   * Retorna o link Geoservice da camada
   * @param {String} urlFullService
   * @param {Object} options
   */
  getGeoserviceLink(urlFullService, layerGeoserviceName) {
    let baseGeoserviceLink = this.getServiceLink(null, urlFullService);
    let layerName = this.getLayerNameParam(urlFullService);
    let layerWorkspaceName = layerName ? layerName.split(':')[0] + '%3A' : '';
    return baseGeoserviceLink && (layerWorkspaceName || layerGeoserviceName)
      ? baseGeoserviceLink +
          '?layers=' +
          layerWorkspaceName +
          layerGeoserviceName
      : urlFullService;
  }

  /**
   * Método para retornar o parametro de nome da camada usado
   * nas requisições de serviços de mapa
   * @param {String} linkFullService
   */
  getLayerNameParam(linkFullService = null) {
    if (this.type === 'interna') {
      return `${this.geoserverWorkspace}:${this.geoserverName}`;
    } else if (this.type === 'externa') {
      let layerName;
      if (!this.properties) {
        layerName = linkFullService
          ? linkFullService.match(/(layers=)[\w\W]+/)
          : null;
      } else {
        layerName = this.properties.link_servico.match(/(layers=)[\w\W]+/);
      }

      layerName = layerName
        ? layerName[0].split('&')[0].replace('%3A', ':').replace('layers=', '')
        : null;
      return layerName;
    }
  }

  /**
   * Obtém o sistema de projeção
   */
  getCrs() {
    if (this.properties.srs) {
      return this.properties.srs;
    }
    return 'EPSG3857';
  }

  /**
   * Método para retornar o titulo da camada, para evitar verificações em vários lugares
   */
  getTitle() {
    if (this.type === 'externa' && this.properties) {
      return this.properties.titulo;
    }
    return this.alias;
  }

  /**
   * Método para obtenção de link do xml do metadado.
   */
  getMetadataXmlLink() {
    if (
      this.type === 'interna' &&
      this.properties &&
      this.properties.metadataLinks &&
      this.properties.metadataLinks.metadataLink &&
      (this.properties.metadataLinks.metadataLink.length > 0 || [this.properties.metadataLinks.metadataLink].length > 0)
    ) {
      let metaDataLink = null;
      let metaDataLinks = Array.isArray(this.properties.metadataLinks.metadataLink) ? 
        this.properties.metadataLinks.metadataLink : 
        [this.properties.metadataLinks.metadataLink];
      metaDataLinks.forEach((mdl) => {
        if (
          !metaDataLink &&
          (mdl.metadataType.toString() === '19139' ||
            mdl.metadataType.toString() === 'ISO19115:2003'||
            mdl.metadataType.toString() === 'ISO19115')
        ) {
          metaDataLink = mdl.content;
        }
      });
      return metaDataLink;
    } else if (this.type === 'externa') {
      return this?.properties?.link_metadado;
    }
    return null;
  }

  /**
   * Método para obtenção de link do xml da pagina do metadado
   */
  getMetadataPageLink() {
    if (this.type === 'interna') {
      let metaDataLink = null;
      let metaDataLinks = Array.isArray(this.properties.metadataLinks.metadataLink) ? 
        this.properties.metadataLinks.metadataLink : 
        [this.properties.metadataLinks.metadataLink];
      metaDataLinks.forEach((mdl) => {
        if (!metaDataLink && mdl.metadataType === 'other') {
          metaDataLink = mdl.content;
        }
      });
      return metaDataLink;
    } else if (this.type === 'externa') {
      return this.properties.pagina;
    }
    return null;
  }

  /**
   * Método para obtenção do bbox da camada
   */
  getBoundingBox() {
    if (this.type === 'interna' && this.properties) {
      return this.properties.latLonBoundingBox;
    } else if (this.type === 'externa') {
      let boundingBoxAttributes = this.properties?.BoundingBox['@attributes'];
      if (
        this.properties.BoundingBox &&
        Array.isArray(this.properties.BoundingBox)
      ) {
        boundingBoxAttributes = this.properties.BoundingBox[0]['@attributes'];
      }
      return boundingBoxAttributes;
    } else if (
      ['criada', 'importada', 'importada-raster'].includes(this.type)
    ) {
      let leafletBounds = this.leafletLayer.getBounds();
      return {
        maxx: leafletBounds.getEast(),
        maxy: leafletBounds.getNorth(),
        minx: leafletBounds.getWest(),
        miny: leafletBounds.getSouth(),
      };
    }
    return null;
  }

  /**
   * Define a camada como selecionada ou não
   * @param {boolean} selected
   */
  setSelected = (selected = true) => (this.isSelected = selected);

  /**
   * Define opacidade da camada
   * @param {number} opacity: ;
   */
  setLayerStyleOpacity = (opacity) => (this.layerStyle.opacity = opacity);

  /**
   * Define preenchimento da camada
   * @param {number} fillOpacity: ;
   */
  setLayerStyleFillOpacity = (fillOpacity) =>
    (this.layerStyle.fillOpacity = fillOpacity);

  /**
   * Define a camada como visivel ou não
   * @param {boolean} visible
   */
  setVisible = (visible = true) => (this.visible = visible);

  /**
   * Define status do rótulo da camada como visivel ou não
   * @param {boolean} visible
   */
  setStatusLabelVisible = (labelVisible = true) =>
    (this.statusLabelVisibility = labelVisible);

  /**
   * Define coluna selecionada como rótulo
   * @param {object} column
   */
  setSelectedLabelColumn = (column) => {
    return (this.selectedLabelColumn = column);
  };

  /**
   * Define La

  /**
   * Define o ZIndex da camada, caso a camada ainda
   * não esteja disponivel, é definido um timeout para uma nova tentativa
   * @param {Number} zIndex
   */
  setZIndex(zIndex) {
    if (this.leafletLayer) {
      this.zIndex = zIndex;
      this.leafletLayer.setZIndex(zIndex);
    } else {
      setTimeout(() => this.setZIndex(zIndex), 200);
    }
  }

  /**
   * Atualiza a lista de feições selecionadas
   *
   * @param {*} features Lista de feições
   * @param {*} ctrlKey Indica se a lista deve ser mesclada ou substituida
   * @param {*} shiftKey Seleciona multiplos registros entre a feixa definida
   */
  setSelectedFeatures(
    features,
    allFeatures = null,
    ctrlKey = false,
    shiftKey = false,
    unselectDuplicated = false
  ) {
    if (features && Array.isArray(features)) {
      if (ctrlKey) {
        let newFeatures = [];
        if (unselectDuplicated) {
          this.selectedFeatures.forEach(
            (f) => !features.includes(f) && newFeatures.push(f)
          );
          features.forEach(
            (f) => !this.selectedFeatures.includes(f) && newFeatures.push(f)
          );
        } else {
          newFeatures = [...this.selectedFeatures];
          features.forEach(
            (f) => !this.selectedFeatures.includes(f) && newFeatures.push(f)
          );
        }
        this.selectedFeatures = newFeatures;
      } else if (shiftKey) {
        let newFeatures = [];
        let firstSelectedFeatureId =
          this.type === 'interna'
            ? this.selectedFeatures[0]?.gid
            : this.selectedFeatures[0]?.properties.ID_GBA;
        let lastSelectedFeatureId =
          this.type === 'interna'
            ? features[0]?.gid
            : features[0]?.properties.ID_GBA;
        let minId = Math.min.apply(Math, [
            firstSelectedFeatureId,
            lastSelectedFeatureId,
          ]),
          maxId = Math.max.apply(Math, [
            firstSelectedFeatureId,
            lastSelectedFeatureId,
          ]);
        if (this.type === 'interna') {
          allFeatures.forEach((f) => {
            f.gid >= minId && f.gid <= maxId && newFeatures.push(f);
          });

          this.selectedFeatures = newFeatures;
        } else {
          this.leafletLayer.eachLayer((f) => {
            f.feature.properties.ID_GBA >= minId &&
              f.feature.properties.ID_GBA <= maxId &&
              newFeatures.push(f.feature);
          });

          this.selectedFeatures =
            lastSelectedFeatureId < firstSelectedFeatureId
              ? newFeatures.reverse()
              : newFeatures;
        }
      } else {
        if (
          unselectDuplicated &&
          features.length === this.selectedFeatures.length
        ) {
          let newFeatures = [];
          features.forEach(
            (f) => !this.selectedFeatures.includes(f) && newFeatures.push(f)
          );
          this.selectedFeatures = newFeatures;
        } else this.selectedFeatures = features;
      }
    }

    if (['importada', 'criada'].includes(this.type) && this.dataType !== 'Text') {
      this.applyFeaturesStyle();
    }
  }

  /**
   * Obtém quantidade de features da camada
   */
  getCountFeatures() {
    let countFeatures = 0;
    this.leafletLayer.eachLayer(() => (countFeatures += 1));
    return countFeatures;
  }

  /**
   * Obtém o conteúdo do Tooltip da feição
   *
   * @param {object} feature
   */
  getTooltipContent(feature) {
    return feature._tooltip?._content;
  }

  /**
   * Obtém os options do Tooltip da feição
   *
   * @param {object} feature
   */
  getTooltipOptions(feature) {
    return feature._tooltip?.options;
  }

  /**
   * Altera visibilidade dos rótulos da camada
   *
   * @param {number} opacity
   */
  setLabelVisibility(opacity) {
    this.leafletLayer._layers &&
      this.leafletLayer.eachLayer((feature) => {
        let tooltipContent = this.getTooltipContent(feature);
        let tooltipOption = this.getTooltipOptions(feature);
        feature.unbindTooltip();
        feature.bindTooltip(tooltipContent, {
          ...tooltipOption,
          opacity: opacity,
        });
      });
  }

  /**
   * Define a coluna de classificação
   *
   * @param {object} classColumn
   */
  setClassColumn = (classColumn) => {
    this.classColumn = classColumn;
  };

  /**
   * Define a escala de cores
   *
   * @param {object} colorScale
   */
  setColorScale = (colorScale) => {
    this.colorScale = colorScale;
  };

  /**
   * Define lista de classes
   *
   * @param {object} classList
   */
  setClassList = (classList) => {
    // serve para setar a lista de classes
    this.classList = classList;
  };

  /**
   * Define lista de classes
   *
   * @param {object} classList
   */

  setSettingsLabel = (settingsLabel) => {
    this.settingsLabel = settingsLabel;
  };

  /**
   * Obtem atributos únicos da coluna
   */
  getColumnUniqueAttributes = (column) => {
    let features = this.leafletLayer._layers;
    let arrFeatures = Object.values(features);
    let arrColumnUniqueAttributes = [];

    arrFeatures.forEach((f) => {
      let attValue = f.feature.properties[column];
      if (!arrColumnUniqueAttributes.includes(attValue))
        arrColumnUniqueAttributes.push(attValue);
    });

    return arrColumnUniqueAttributes;
  };

  /*
   * Gera um hexadecimal randomicamente
   */
  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  /**
   * Gera lista de cores
   */
  generateListOfColor = async (classColumn, colorScale) => {
    let listColor = [];
    let listColumnAttributes = this.getColumnUniqueAttributes(classColumn);

    if (colorScale === 'colorido') {
      listColor = await Promise.all(
        listColumnAttributes.map(async () => {
          let hex = this.getRandomColor();
          return hex;
        })
      );
    } else {
      let lengthListColumnAttributes = listColumnAttributes.length;
      listColor = colorGradient
        .setGradient(colorScale, '#e5e5e5')
        .setMidpoint(--lengthListColumnAttributes)
        .getArray();
      listColor.unshift(colorScale);
    }

    return listColor;
  };

  /**
   * Gera uma lista de classes
   *
   * @param {object} classColumn
   * @param {object} colorScale
   */
  generateClassList = async (classColumn = null, colorScale = null) => {
    if (classColumn && colorScale) {
      let listColumnAttributes = this.getColumnUniqueAttributes(classColumn);
      let colorList = await this.generateListOfColor(classColumn, colorScale);

      let arrClassList = await Promise.all(
        listColumnAttributes.map(async (att, i) => {
          return {
            value: att,
            simbology: { fillColor: colorList[i] },
          };
        })
      );

      let newClassList = await arrClassList;

      return newClassList;
    } else {
      return null;
    }
  };
  /**
   *  Aplica rotulos nas camadas
   *  TODO: refatorar codigo, pois esta sendo duplicado a logica em outros lugares do codigo
   */
  addLabel = (layer, paramColumnLabel) => {
    if (paramColumnLabel) {
      let settingsLabel = {};
      layer.leafletLayer.eachLayer((feature) => {
        settingsLabel = {
          columnName: paramColumnLabel,
          feature: feature,
          fontColor: layer.settingsLabel.fontColor || '#000000',
          outlineColor: layer.settingsLabel.outlineColor || '#ffffff',
          isFontBold: layer.settingsLabel.isFontBold || false,
          fontSize: layer.settingsLabel.fontSize || 12,
          direction: layer.settingsLabel.direction || 'ltr',
          opacity: layer.settingsLabel.opacity || 1,
        };
        applyLabelSetting(settingsLabel);
      });
      // Define a coluna como rótulo (Utilizado na tabela de atributos)
      layer.selectedLabelColumn = {
        label: paramColumnLabel,
        name: paramColumnLabel,
      };
      // Status de visibilidade do rótulo
      layer.setStatusLabelVisible(true);
    }
  };

  /**
   * Aplica estilização nas feições
   */
  applyFeaturesStyle = (resetVisibilityFeature = false) => {
    let hasEditSimbology = this.classList.length > 0;

    this.leafletLayer.eachLayer((feature) => {
      let optionsFeatureStyle = { ...feature.options.style };
      let optionsOpacity = {
        opacity: resetVisibilityFeature
          ? this.layerStyle.opacity
          : this.visible
          ? feature.options.opacity !== undefined
            ? feature.options.opacity
            : this.layerStyle.opacity
          : 0,
        fillOpacity: resetVisibilityFeature
          ? this.layerStyle.fillOpacity
          : this.visible
          ? feature.options.fillOpacity !== undefined
            ? feature.options.fillOpacity
            : this.layerStyle.fillOpacity
          : 0,
      };

      // Verifica se a camada possui classificação de simbologia
      if (hasEditSimbology > 0) {
        let featureStyle = this.classList.find(
          (c) => c.value === feature.feature.properties[this.classColumn]
        );

        if (featureStyle) {
          optionsFeatureStyle = {
            ...optionsFeatureStyle,
            color: featureStyle.simbology.fillColor,
            fillColor: featureStyle.simbology.fillColor,
            ...optionsOpacity,
          };
          // Quando o tipo de geometria for 'GeometryCollection'
          // eh necessário setar os atributos
          if (this.dataType === 'GeometryCollection') {
            feature.options = {
              ...optionsFeatureStyle,
            };
          }

          feature.setStyle({
            ...optionsFeatureStyle,
          });
        }
      } else {
        if (['Point', 'MultiPoint'].includes(this.dataType)) {
          // Se o dataType for Point ou MultiPoint, copia as opções de estilo da camada feature.defaultOptions
          optionsFeatureStyle = { ...feature.defaultOptions };
        } else if (['GeometryCollection'].includes(this.dataType)) {
          optionsFeatureStyle = { ...this.layerStyle };
          // Quando o tipo de geometria for 'GeometryCollection'
          // eh necessário setar os atributos
          feature.options = {
            ...optionsFeatureStyle,
            ...optionsOpacity,
          };
        }

        // Define o estilo da camada feature com as opçõesStyle calculadas
        typeof feature.setStyle !== "undefined" && feature.setStyle({
          ...optionsFeatureStyle,
          ...optionsOpacity,
        });
      }
    });

    // Aplica estilo da feição selecionada
    if (this.selectedFeatures.length) {
      this.applyStyleSelectedFeatures();
    }
  };

  /**
   * Aplica estilo nas feições selecionadas para diferenciar das demais
   */
  applyStyleSelectedFeatures = () => {
    // Obtém atributos de estilização padrão da aplicação
    // pelo tipo da camada (ponto, linha ou polígono)
    let layerStyle = selectedFeaturesStyles.find((s) =>
      s.for.includes(this.dataType)
    );

    this.leafletLayer.eachLayer((feature) => {
      this.selectedFeatures.includes(feature.feature) &&
        typeof feature.setStyle !== "undefined" && feature.setStyle({
          ...layerStyle,
          opacity: feature.options.opacity
            ? feature.options.opacity
            : this.layerStyle.opacity,
          fillOpacity: feature.options.fillOpacity
            ? feature.options.fillOpacity
            : this.layerStyle.fillOpacity,
          weight: 4,
        });
    });
  };

  /**
   * Atualiza classificação
   *
   * @param {object} classColumn
   * @param {object} colorScale
   */
  updateFeaturesStyle = (classColumn = null, colorScale = null) => {
    if (classColumn) this.setClassColumn(classColumn);
    if (colorScale) this.setColorScale(colorScale);

    this.generateClassList(classColumn, colorScale)
      .then((classList) => {
        this.setClassList(classList);
        this.applyFeaturesStyle();
      })
      .catch((err) =>
        console.error('Não foi possível gerar a lista de classes', err)
      );
  };

  /**
   * Tranforma uma imagem em base64 a partir da URL
   *
   * @param {string} url
   */
  toDataURL = (url) => {
    return fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  };

  /**
   * Obtém e atualiza da legenda de camadas providas por serviço
   *
   * @param {object} legendGraphicParams
   */
  getServiceLegend = (legendGraphicParams) => {
    return this.toDataURL(
      `${this.getServiceLink()}?${toUrlFormat(legendGraphicParams)}`
    );
  };

  /**
   * Obtem o ícone de classificação
   */

  getClassificationIcon = (fillColor, opacity, fillOpacity) => {
    const geometryType = this.layerStyle.for;

    let iconComponent = null;

    switch (geometryType) {
      case 'Point':
        iconComponent = (
          <Icon
            i={'map-editsymbology-classpoint'}
            stroke={fillColor}
            fillOpacity={opacity}
            strokeOpacity={opacity}
            fill={fillColor}
          />
        );
        break;
      case 'Line':
        iconComponent = (
          <Icon
            i={'map-editsymbology-classline'}
            stroke={fillColor}
            fillOpacity={opacity}
            strokeOpacity={opacity}
            fill={fillColor}
          />
        );
        break;
      case 'Polygon':
        iconComponent = (
          <svg
            width={18}
            height={18}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.56843 17.3751L0.339844 8.7774L6.48107 0.179688L17.5353 11.2339L6.56843 17.3751Z"
              fill={fillColor}
              fillOpacity={fillOpacity}
              stroke={fillColor}
              strokeOpacity={opacity}
              strokeWidth={0.5}
            />
          </svg>
        );
        break;
      default:
        // Se o tipo de geometria não corresponder, pode retornar um ícone padrão ou fazer outra ação necessária.
        break;
    }

    return iconComponent;
  };

  /**
   * Verifica se feature intersecta o polígono do bbox do mapa
   */
  isFeatureInBboxMap = (mBbox, feature) => {
    if (['Point', 'MultiPoint'].includes(feature.geometry.type)) {
      var latlng = L.latLng(
        feature.geometry.coordinates[1],
        feature.geometry.coordinates[0]
      );
      if (mBbox.contains(latlng)) {
        return true;
      } else {
        return false;
      }
    } else {
      let arrBBox = [
        mBbox.getNorthEast().lng,
        mBbox.getNorthEast().lat,
        mBbox.getSouthWest().lng,
        mBbox.getSouthWest().lat,
      ];
      let mapBBoxPolygon = turf.bboxPolygon(arrBBox);

      if (
        ['Line', 'LineString', 'MultiLineString'].includes(
          feature.geometry.type
        )
      ) {
        let lineTurf = ['MultiLineString'].includes(feature.geometry.type)
          ? turf.multiLineString(feature.geometry.coordinates)
          : turf.lineString(feature.geometry.coordinates);

        return turf.booleanIntersects(mapBBoxPolygon, lineTurf);
      } else if (['Polygon', 'MultiPolygon'].includes(feature.geometry.type)) {
        let polygonTurf = ['MultiPolygon'].includes(feature.geometry.type)
          ? turf.multiPolygon(feature.geometry.coordinates)
          : turf.polygon(feature.geometry.coordinates);

        return turf.intersect(mapBBoxPolygon, polygonTurf) !== null
          ? true
          : false;
      } else if (['GeometryCollection'].includes(feature.geometry.type)) {
        let polygonTurf = turf.geometryCollection(feature.geometry.geometries);

        return turf.booleanIntersects(mapBBoxPolygon, polygonTurf);
      } else {
        return true;
      }
    }
  };

  /**
   * Obtém features que estão na área visível do mapa
   */
  getFeaturesInBboxMap = (mBbox) => {
    let arrFeatureInBbox = [];

    this.leafletLayer.eachLayer((f) => {
      if (this.isFeatureInBboxMap(mBbox, f.feature)) {
        arrFeatureInBbox.push(f.feature);
      }
    });

    return arrFeatureInBbox;
  };

  /**
   * Obtém classificação de simbologia das feições informadas
   */
  getClassListFromFeatures = (arrFeatureInBbox) => {
    let classColumn = this.classColumn;
    let featureInBbox = null;

    return this.classList.filter(function (cl) {
      featureInBbox = arrFeatureInBbox.find(
        (fib) => fib.properties[classColumn] === cl.value
      );
      return (
        featureInBbox && cl.value === featureInBbox.properties[classColumn]
      );
    });
  };

  /**
   * Cria legenda das camadas criadas e importadas
   */
  getStaticLegend = (
    mBbox,
    legendToPrint = false,
    fillColor,
    fillOpacity,
    opacity
  ) => {
    let geometryType = this.layerStyle.for;
    // let layerColor = this.layerStyle.fillColor;
    let layerAlias = this.alias;
    let arrFeatureInBbox,
      symbolLegendList = [];

    arrFeatureInBbox = this.dataType === 'Text'
                        ? []
                        : this.getFeaturesInBboxMap(mBbox);

    if (this.classList.length > 0) {
      symbolLegendList = this.getClassListFromFeatures(arrFeatureInBbox);
    }

    return (
      <div id={`legend-${this.id}`}>
        {this.classList.length > 0 ? (
          <div className="classification-legend">
            <table>
              {symbolLegendList.map((legendRow, iLegendRow) => {
                return (
                  <tr key={iLegendRow}>
                    <td
                      className="simbol-legend"
                      style={{ paddingTop: legendToPrint && '1px' }}
                    >
                      {this.getClassificationIcon(
                        legendRow.simbology.fillColor,
                        opacity,
                        fillOpacity
                      )}
                    </td>
                    <td
                      style={{
                        paddingTop: legendToPrint && '1px',
                        paddingBottom: legendToPrint && '8px',
                      }}
                    >
                      {legendRow.nickname
                        ? legendRow.nickname
                        : legendRow.value}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        ) : (
          <div className="static-legend">
            {arrFeatureInBbox.length > 0 ? (
              <div>
                <svg
                  width={geometryType === 'Point' ? '25' : '20'}
                  height={geometryType === 'Point' ? '25' : '20'}
                  viewBox={geometryType === 'Point' ? '0 0 25 25' : '0 0 20 20'}
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {geometryType === 'Polygon' && (
                    <path
                      d="M 0.1386 0.1386 H 20 V 20 H 0.1386 V 0.1386 Z"
                      fill={fillColor}
                      fillOpacity={fillOpacity}
                      stroke={fillColor}
                      fillRule="evenodd"
                      strokeOpacity={opacity}
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  )}
                  {geometryType === 'Line' && (
                    <path
                      d="M 0.3535 0.6465 L 20 20"
                      fill={fillColor}
                      fillOpacity={opacity}
                      strokeOpacity={opacity}
                      stroke={fillColor}
                      fillRule="evenodd"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  )}
                  {geometryType === 'Point' && (
                    <path
                      d="M14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24Z"
                      stroke={fillColor}
                      fillOpacity={opacity}
                      strokeOpacity={opacity}
                      fill={fillColor}
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fillRule="evenodd"
                    />
                  )}
                </svg>
                <span>{layerAlias}</span>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  };

  /** Event Handlers */

  /**
   * Adiciona um callback a um evento
   *
   * @param {*} eventName Nome do evento
   * @param {*} callback Callback
   */
  addEventListener(eventName, callback) {
    if (
      eventName &&
      callback &&
      typeof eventName === 'string' &&
      typeof callback === 'function'
    ) {
      this.events.push({ eventName, callback });
    }
  }

  /**
   * Remove um callback de um evento
   *
   * @param {*} eventName Nome do evento
   * @param {*} callback Callback
   */
  removeEventListener(eventName, callback) {
    if (
      eventName &&
      callback &&
      typeof eventName === 'string' &&
      typeof callback === 'function'
    ) {
      this.events = this.events.filter(
        (ev) => ev.eventName === eventName && ev.callback === callback
      );
    }
  }

  /**
   * Dispara um callback associado a um evento
   *
   * @param {*} eventName Nome do evento
   * @param {*} eventData Dados do evento
   */
  _fireEvent(eventName, eventData) {
    if (eventName && typeof eventName === 'string') {
      this.events.forEach(
        (ev) => ev.eventName === eventName && ev.callback(eventData)
      );
    }
  }

  /** RENDERIZAÇÕES */
  /**
   * @param {string} type [simplified, verbose]
   * @returns Retorna a lista aninhada por categoria
   */
  nested(type = 'simplified') {
    return {
      'CAT-9999': {
        categoria_codinome: 'Exemplo',
        children: ['aqui vao os filhos'],
      },
    };
  }
}
